/* eslint-disable */

export interface CaseDetailDto {
  id: string;
  subject: string;
  description?: string | null;
  criticality: number;
  stress: number;
  reason: string;
  type: string;
  product: string;
  topic: string;
  deadline?: Date | null;
  accountId: string;
  contactId: string;
}

export const fixCaseDetailDtoFromJson = (dto?: CaseDetailDto | null): void => {
  if (!dto) {
    return;
  }
  dto.deadline = dto.deadline && new Date(dto.deadline);
};

export const fixCaseDetailDtoToJson = (dto?: CaseDetailDto | null): void => {
  if (!dto) {
    return;
  }
};
